import './Button.css';

/**
 * Button — composant de bouton universel
 *
 * @param {string}   variant   - 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger' | 'success'
 * @param {string}   size      - 'sm' | 'md' | 'lg'
 * @param {boolean}  loading   - affiche un spinner et désactive le bouton
 * @param {boolean}  fullWidth - prend toute la largeur disponible
 * @param {node}     leftIcon  - icône à gauche du texte
 * @param {node}     rightIcon - icône à droite du texte
 */
const Button = ({
  children,
  type       = 'button',
  variant    = 'primary',
  size       = 'md',
  onClick,
  disabled,
  loading    = false,
  fullWidth  = false,
  leftIcon,
  rightIcon,
  className  = '',
  ...rest
}) => {
  const isDisabled = disabled || loading;

  return (
    <button
      type={type}
      className={[
        'btn',
        `btn--${variant}`,
        `btn--${size}`,
        fullWidth  ? 'btn--full'    : '',
        loading    ? 'btn--loading' : '',
        className,
      ].filter(Boolean).join(' ')}
      onClick={onClick}
      disabled={isDisabled}
      aria-busy={loading}
      {...rest}
    >
      {loading && (
        <span className="btn__spinner" aria-hidden="true" />
      )}
      {!loading && leftIcon && (
        <span className="btn__icon btn__icon--left">{leftIcon}</span>
      )}
      {children && <span className="btn__text">{children}</span>}
      {!loading && rightIcon && (
        <span className="btn__icon btn__icon--right">{rightIcon}</span>
      )}
    </button>
  );
};

export default Button;
